import { render, staticRenderFns } from "./ProductSpecsElementCreate.vue?vue&type=template&id=5ac35a1a"
import script from "./ProductSpecsElementCreate.vue?vue&type=script&lang=js"
export * from "./ProductSpecsElementCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac35a1a')) {
      api.createRecord('5ac35a1a', component.options)
    } else {
      api.reload('5ac35a1a', component.options)
    }
    module.hot.accept("./ProductSpecsElementCreate.vue?vue&type=template&id=5ac35a1a", function () {
      api.rerender('5ac35a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecsElement/ProductSpecsElementCreate.vue"
export default component.exports